import _uniq from 'lodash/uniq';
import _sortBy from 'lodash/sortBy';
import _get from 'lodash/get';
import _some from 'lodash/some';
import {
  ACTIVE_KEY,
  STRUCTURED_DISPLAY_NAME_BY_CODE,
} from '../../../../../common/engine/utilities/constants';

export const convertTextToId = (text) =>
  text.replace(/(\s|\W)/g, '').toLowerCase();

export const getAdjustmentIsToggledActive = (
  adjustmentToggles,
  groupName,
  adjustmentName
) => _get(adjustmentToggles, [groupName, adjustmentName, ACTIVE_KEY], true);

export const getLinksDescriptor = (links = []) => {
  const hasLinks = links.length > 0;
  let hasBrokenLinks = false;

  if (hasLinks) {
    hasBrokenLinks = _some(links, (link) => _get(link, 'isBroken', false));
  }

  return {
    hasLinks,
    hasBrokenLinks,
  };
};

export const getGroupLinksDescriptor = (groupName, linkedAdjustments) => {
  const linksForGroup = linkedAdjustments.filter((link) => {
    const linkSourceType = _get(link, ['source', 'adjustmentType'], null);
    return linkSourceType === groupName;
  });

  const descriptor = getLinksDescriptor(linksForGroup);

  return descriptor;
};

export const getLinksForAdjustment = (
  groupName,
  adjustmentDisplayName,
  linkedAdjustments
) => {
  const linksForAdjustment = linkedAdjustments.filter((link) => {
    const linkSourceType = _get(link, ['source', 'adjustmentType'], null);
    const linkSourceDisplayName = _get(
      link,
      ['source', 'adjustmentDisplayName'],
      null
    );
    return (
      linkSourceType === groupName &&
      linkSourceDisplayName === adjustmentDisplayName
    );
  });

  return linksForAdjustment;
};

export const getLinksPopoverData = (linkedAdjustments) => {
  const distinctTargetDocuments = _uniq(
    linkedAdjustments.map((link) =>
      _get(link, ['target', 'documentCode'], 'UNKNOWN')
    )
  );

  const popoverData = distinctTargetDocuments.map((targetDoc) => {
    const targetDocLinks = linkedAdjustments.filter(
      (link) => _get(link, ['target', 'documentCode'], null) === targetDoc
    );
    const sortedTargetDocLinks = _sortBy(targetDocLinks, (link) =>
      _get(link, ['target', 'adjustmentNumber'], 0)
    );
    const sortedTargetDocLinksForPopover = sortedTargetDocLinks.map((link) => ({
      displayName: _get(link, ['target', 'adjustmentDisplayName'], 'UNKNOWN'),
      isBroken: link.isBroken,
      queryString: _get(link, ['target', 'queryString'], null),
    }));

    return {
      documentCode: targetDoc,
      documentDisplayName: STRUCTURED_DISPLAY_NAME_BY_CODE[targetDoc],
      links: sortedTargetDocLinksForPopover,
    };
  });

  const sortedByTargetDocPopoverData = _sortBy(
    popoverData,
    'documentDisplayName'
  );

  return sortedByTargetDocPopoverData;
};
